export default __webpack_public_path__ + "static/media/(7).b1cd75d9.jpeg";